"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CategoryType;
(function (CategoryType) {
    CategoryType["JOURNEY"] = "journey";
    CategoryType["MEMBERSHIP_TYPE"] = "membershiptype";
    CategoryType["PATHWAY"] = "pathway";
    CategoryType["EXEMPTION_TYPE"] = "exemptiontype";
    CategoryType["DOCUMENT_STATUS"] = "documentstatus";
    CategoryType["DONATION"] = "donation";
    CategoryType["GENERIC"] = "generic";
})(CategoryType = exports.CategoryType || (exports.CategoryType = {}));
var CategoryJourneyValue;
(function (CategoryJourneyValue) {
    CategoryJourneyValue["MEMBERSHIP_RENEWAL"] = "Membership-Renewal";
    CategoryJourneyValue["CIMA_RENEWAL_STUDENT"] = "CIMA-Renewal-Student";
    CategoryJourneyValue["CIMA_RENEWAL_MEMBER"] = "CIMA-Renewal-Member";
    CategoryJourneyValue["CIMA_SIGNUP"] = "CIMA-Signup";
    CategoryJourneyValue["AICPA_SIGNUP"] = "AICPA-Signup";
    CategoryJourneyValue["CREDENTIAL_SIGNUP"] = "Credential-Signup";
    CategoryJourneyValue["CREDENTIAL_RENEWAL"] = "Credential-Renewal";
})(CategoryJourneyValue = exports.CategoryJourneyValue || (exports.CategoryJourneyValue = {}));
var CategoryMembershipTypeValue;
(function (CategoryMembershipTypeValue) {
    CategoryMembershipTypeValue["RETIRED"] = "Retired";
    CategoryMembershipTypeValue["REGULAR"] = "Regular";
    CategoryMembershipTypeValue["AFFILIATE"] = "Affiliate";
    CategoryMembershipTypeValue["CANDIDATE"] = "Candidate";
    CategoryMembershipTypeValue["CGMA_AFFILIATE"] = "CGMA Affiliate";
})(CategoryMembershipTypeValue = exports.CategoryMembershipTypeValue || (exports.CategoryMembershipTypeValue = {}));
var CategoryPathwayValue;
(function (CategoryPathwayValue) {
    CategoryPathwayValue["PQ"] = "PQ";
    CategoryPathwayValue["FLP"] = "FLP";
    CategoryPathwayValue["APP_L4"] = "APP-L4";
    CategoryPathwayValue["APP_L7"] = "APP-L7";
})(CategoryPathwayValue = exports.CategoryPathwayValue || (exports.CategoryPathwayValue = {}));
var CategoryExemptionTypeValue;
(function (CategoryExemptionTypeValue) {
    CategoryExemptionTypeValue["CONDITIONAL_EDUCATIONAL"] = "Conditional-Educational";
    CategoryExemptionTypeValue["EDUCATIONAL"] = "Educational";
    CategoryExemptionTypeValue["PROFESSIONAL"] = "Professional";
    CategoryExemptionTypeValue["EXPERIENTIAL"] = "Experiential";
})(CategoryExemptionTypeValue = exports.CategoryExemptionTypeValue || (exports.CategoryExemptionTypeValue = {}));
var CategoryDocumentStatusValue;
(function (CategoryDocumentStatusValue) {
    CategoryDocumentStatusValue["ALL"] = "All";
    CategoryDocumentStatusValue["PARTIAL"] = "Partial";
    CategoryDocumentStatusValue["NONE"] = "None";
})(CategoryDocumentStatusValue = exports.CategoryDocumentStatusValue || (exports.CategoryDocumentStatusValue = {}));
var CategoryDonationValue;
(function (CategoryDonationValue) {
    CategoryDonationValue["YES"] = "Yes";
    CategoryDonationValue["NO"] = "No";
})(CategoryDonationValue = exports.CategoryDonationValue || (exports.CategoryDonationValue = {}));
var CategoryGenericValue;
(function (CategoryGenericValue) {
    CategoryGenericValue["CIMA"] = "CIMA";
    CategoryGenericValue["CIMA_UNABLE_TO_ATTEST"] = "CIMA-UnableToAttest";
    CategoryGenericValue["AICPA"] = "AICPA";
})(CategoryGenericValue = exports.CategoryGenericValue || (exports.CategoryGenericValue = {}));
//# sourceMappingURL=Attestations.js.map